export const categories = [
  { id: "romance", name: "恋爱甜宠", icon: "ri-heart-line", color: "bg-rose-100 text-rose-700" },
  { id: "fantasy", name: "奇幻冒险", icon: "ri-magic-line", color: "bg-amber-100 text-amber-700" },
  { id: "action", name: "热血动作", icon: "ri-fire-line", color: "bg-orange-100 text-orange-700" },
  { id: "drama", name: "都市情感", icon: "ri-building-2-line", color: "bg-teal-100 text-teal-700" },
  { id: "comedy", name: "搞笑日常", icon: "ri-emotion-laugh-line", color: "bg-lime-100 text-lime-700" },
  { id: "thriller", name: "悬疑惊悚", icon: "ri-ghost-line", color: "bg-indigo-100 text-indigo-700" },
  { id: "historical", name: "古风历史", icon: "ri-book-2-line", color: "bg-stone-100 text-stone-700" },
  { id: "bl", name: "BL专区", icon: "ri-men-line", color: "bg-sky-100 text-sky-700" },
];

export const comicTags = ["独家", "热门", "新作", "完结", "连载中"];

export const comics = [
  {
    id: 1,
    title: "繁星坠落之夜",
    author: "金素英",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20soft%20watercolor%20aesthetics%2C%20a%20young%20couple%20under%20starry%20night%20sky%2C%20warm%20pastel%20tones%2C%20emotional%20atmosphere%2C%20beautiful%20illustration%20with%20delicate%20linework%2C%20Korean%20webtoon%20style%20cover%20design%2C%20soft%20lighting%20and%20romantic%20mood%2C%20clean%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    category: "romance",
    tags: ["热门", "独家"],
    rating: 9.6,
    views: "1280万",
    status: "连载中",
    updateTo: "第128话",
    updatedAt: "2026-08-05",
    description: "在一个流星划过夜空的夜晚，普通女高中生林小星遇到了神秘转学生。他们的相遇如同命运的安排，一段跨越时空的浪漫爱情故事就此展开。当星辰与命运交织，她能否守护住这份来之不易的爱情？",
    chapters: 128,
  },
  {
    id: 2,
    title: "暗影刺客",
    author: "朴志勋",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20dark%20urban%20setting%2C%20a%20mysterious%20assassin%20in%20black%20coat%20with%20hidden%20weapons%2C%20dynamic%20pose%2C%20dramatic%20lighting%20with%20neon%20accents%2C%20Korean%20webtoon%20style%2C%20high%20contrast%20illustration%2C%20intense%20atmosphere%2C%20clean%20sharp%20linework&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    category: "action",
    tags: ["热门"],
    rating: 9.3,
    views: "980万",
    status: "连载中",
    updateTo: "第95话",
    updatedAt: "2026-08-04",
    description: "在这个被黑暗势力笼罩的城市中，一个神秘的刺客组织暗中操控着一切。主角韩宇轩曾是组织最强的杀手，直到他决定背叛。一场关于复仇与救赎的史诗级动作故事，每一页都充满张力。",
    chapters: 95,
  },
  {
    id: 3,
    title: "异世界料理王",
    author: "李美妍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20colorful%20magical%20cooking%20scene%2C%20a%20chef%20in%20fantasy%20world%20with%20floating%20ingredients%20and%20magical%20dishes%2C%20warm%20vibrant%20colors%2C%20playful%20illustration%20style%2C%20Korean%20webtoon%20aesthetic%2C%20whimsical%20and%20appetizing%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    category: "fantasy",
    tags: ["新作", "独家"],
    rating: 9.1,
    views: "650万",
    status: "连载中",
    updateTo: "第72话",
    updatedAt: "2026-08-04",
    description: "顶级厨师意外穿越到剑与魔法的异世界，却发现这里的美食文化极度匮乏。用现代料理技巧征服异世界食客的胃，顺便拯救世界的搞笑又热血的冒险故事！",
    chapters: 72,
  },
  {
    id: 4,
    title: "都市夜语",
    author: "郑恩淑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20modern%20city%20nightscape%2C%20a%20stylish%20young%20woman%20in%20office%20attire%20looking%20out%20over%20city%20lights%2C%20elegant%20and%20mature%20tone%2C%20Korean%20webtoon%20style%2C%20sophisticated%20illustration%20with%20warm%20night%20lighting%2C%20emotional%20and%20introspective%20mood&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    category: "drama",
    tags: ["热门"],
    rating: 9.5,
    views: "1560万",
    status: "完结",
    updateTo: "已完结",
    updatedAt: "2026-07-28",
    description: "在繁华都市的霓虹灯下，四位职场女性各自面临着事业与爱情的抉择。她们的命运在某个夜晚的相遇中交织在一起，展现当代都市女性的真实生活与内心世界。",
    chapters: 156,
  },
  {
    id: 5,
    title: "魔王大人想退休",
    author: "韩智浩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20a%20powerful%20demon%20lord%20in%20cute%20chibi%20style%20trying%20to%20live%20a%20normal%20life%2C%20bright%20and%20cheerful%20colors%2C%20humorous%20illustration%2C%20Korean%20webtoon%20style%2C%20lighthearted%20and%20funny%20composition%2C%20expressive%20character%20design&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    category: "comedy",
    tags: ["热门", "独家"],
    rating: 9.2,
    views: "890万",
    status: "连载中",
    updateTo: "第64话",
    updatedAt: "2026-08-03",
    description: "统治魔界千年的最强魔王终于厌倦了打打杀杀的生活，决定退休去人间开一家咖啡店。然而人间的各种麻烦比魔界还难搞，笑料百出的日常喜剧就此拉开帷幕！",
    chapters: 64,
  },
  {
    id: 6,
    title: "血色蔷薇",
    author: "崔敏雅",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20mysterious%20dark%20aesthetic%2C%20a%20woman%20surrounded%20by%20red%20roses%20with%20hidden%20secrets%2C%20suspenseful%20atmosphere%2C%20deep%20red%20and%20black%20color%20scheme%2C%20Korean%20webtoon%20style%2C%20intricate%20and%20mysterious%20illustration%2C%20gothic%20romantic%20undertone&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    category: "thriller",
    tags: ["新作"],
    rating: 8.9,
    views: "430万",
    status: "连载中",
    updateTo: "第38话",
    updatedAt: "2026-08-02",
    description: "一朵朵血色蔷薇在深夜盛开，每一朵都预示着一个秘密的揭开。女主林素妍搬进一栋古老公寓后，开始发现邻居们隐藏的惊人秘密，而她自己似乎也被卷入了一场精心策划的阴谋。",
    chapters: 38,
  },
  {
    id: 7,
    title: "长安夜行录",
    author: "安在旭",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20cover%20art%2C%20ancient%20East%20Asian%20palace%20setting%2C%20a%20noble%20warrior%20in%20traditional%20hanbok%20inspired%20costume%20under%20moonlight%2C%20elegant%20traditional%20art%20style%20blend%2C%20Korean%20webtoon%20with%20historical%20aesthetics%2C%20atmospheric%20night%20scene%2C%20refined%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    category: "historical",
    tags: ["独家", "热门"],
    rating: 9.7,
    views: "2100万",
    status: "连载中",
    updateTo: "第210话",
    updatedAt: "2026-08-05",
    description: "唐朝长安城内，一位身负血海深仇的少年伪装成宫中侍卫，潜入深宫追查灭门真凶。在这条充满权谋与背叛的路上，他遇到了改变他一生的人。恢弘的史诗级古风漫画。",
    chapters: 210,
  },
  {
    id: 8,
    title: "薄荷糖之恋",
    author: "尹智恩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%20art%2C%20two%20young%20men%20sharing%20a%20tender%20moment%20in%20a%20cafe%2C%20soft%20pastel%20mint%20green%20and%20pink%20color%20palette%2C%20gentle%20and%20sweet%20atmosphere%2C%20Korean%20webtoon%20style%2C%20clean%20and%20delicate%20illustration%2C%20warm%20lighting%20and%20romantic%20mood&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    category: "bl",
    tags: ["热门"],
    rating: 9.4,
    views: "720万",
    status: "连载中",
    updateTo: "第56话",
    updatedAt: "2026-08-03",
    description: "在大学附近的薄荷咖啡店里，咖啡师金泰亨遇到了每天来点同一杯饮品的郑河润。一颗薄荷糖，一杯咖啡，一段从陌生到熟悉的甜蜜故事。清新治愈系BL漫画。",
    chapters: 56,
  },
  {
    id: 9,
    title: "拳皇传说",
    author: "权相佑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fighting%20action%20cover%20art%2C%20a%20powerful%20martial%20artist%20in%20dynamic%20fighting%20stance%2C%20explosive%20action%20scene%20with%20energy%20effects%2C%20intense%20red%20and%20orange%20color%20scheme%2C%20Korean%20webtoon%20style%2C%20powerful%20and%20muscular%20character%20design%2C%20dramatic%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    category: "action",
    tags: ["热门"],
    rating: 9.0,
    views: "1100万",
    status: "连载中",
    updateTo: "第142话",
    updatedAt: "2026-08-05",
    description: "从街头混混到世界拳王，这是一部关于梦想、汗水和永不言弃的热血故事。主角金政秀在人生最低谷时遇见了改变他命运的拳击教练，从此踏上了追逐荣耀的道路。",
    chapters: 142,
  },
  {
    id: 10,
    title: "我的猫咪会说话",
    author: "沈慧珍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20a%20cute%20talking%20cat%20with%20its%20owner%20in%20a%20cozy%20apartment%2C%20warm%20and%20comforting%20colors%2C%20adorable%20illustration%20style%2C%20Korean%20webtoon%20aesthetic%2C%20heartwarming%20and%20playful%20mood%2C%20clean%20charming%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    category: "comedy",
    tags: ["新作"],
    rating: 9.3,
    views: "580万",
    status: "连载中",
    updateTo: "第48话",
    updatedAt: "2026-08-04",
    description: "普通上班族金多喜某天醒来发现自己的猫竟然会说话了！而且这只猫居然自称是从喵星来的特派员，要在地球执行神秘任务。爆笑又温馨的日常喜剧，治愈你的每一天。",
    chapters: 48,
  },
  {
    id: 11,
    title: "魔法学院优等生",
    author: "张瑞妍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20cover%20art%2C%20students%20in%20magical%20school%20uniforms%20casting%20spells%2C%20colorful%20magic%20effects%2C%20bright%20and%20vibrant%20illustration%2C%20Korean%20webtoon%20fantasy%20style%2C%20dynamic%20and%20energetic%20composition%2C%20beautiful%20magical%20atmosphere&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    category: "fantasy",
    tags: ["热门", "独家"],
    rating: 9.5,
    views: "1350万",
    status: "连载中",
    updateTo: "第180话",
    updatedAt: "2026-08-05",
    description: "出身平民的天才少女考入全国最顶尖的魔法学院，面对贵族同学的排挤和神秘黑暗势力的威胁，她凭借过人的天赋与不屈的意志一步步攀登魔法巅峰。华丽的魔法对决场面令人叹为观止。",
    chapters: 180,
  },
  {
    id: 12,
    title: "心跳加速",
    author: "柳真雅",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20high%20school%20romance%20cover%20art%2C%20a%20blushing%20schoolgirl%20and%20a%20handsome%20boy%20in%20school%20uniform%2C%20cherry%20blossom%20petals%20falling%2C%20soft%20pink%20and%20white%20color%20palette%2C%20Korean%20webtoon%20style%2C%20sweet%20and%20youthful%20atmosphere%2C%20spring%20romantic%20vibe&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    category: "romance",
    tags: ["新作"],
    rating: 9.1,
    views: "460万",
    status: "连载中",
    updateTo: "第36话",
    updatedAt: "2026-08-02",
    description: "因为一次意外的心脏移植手术，女主角获得了感知他人情绪的特殊能力。在新学校里，她发现那个全校最受欢迎的男生竟然有着不为人知的内心世界。一场关于青春、心跳与秘密的校园恋爱故事。",
    chapters: 36,
  },
];

export const rankings = {
  popularity: [
    { rank: 1, comicId: 7, change: "up" },
    { rank: 2, comicId: 4, change: "same" },
    { rank: 3, comicId: 1, change: "up" },
    { rank: 4, comicId: 11, change: "down" },
    { rank: 5, comicId: 9, change: "up" },
    { rank: 6, comicId: 2, change: "down" },
    { rank: 7, comicId: 5, change: "new" },
    { rank: 8, comicId: 8, change: "up" },
    { rank: 9, comicId: 3, change: "down" },
    { rank: 10, comicId: 6, change: "new" },
  ],
  weekly: [
    { rank: 1, comicId: 11, change: "up" },
    { rank: 2, comicId: 7, change: "same" },
    { rank: 3, comicId: 1, change: "up" },
    { rank: 4, comicId: 2, change: "new" },
    { rank: 5, comicId: 9, change: "down" },
    { rank: 6, comicId: 10, change: "up" },
    { rank: 7, comicId: 5, change: "down" },
    { rank: 8, comicId: 12, change: "new" },
    { rank: 9, comicId: 8, change: "up" },
    { rank: 10, comicId: 3, change: "down" },
  ],
};

export const banners = [
  {
    id: 1,
    comicId: 7,
    title: "长安夜行录 — 年度最佳古风漫画",
    subtitle: "恢弘史诗 · 210话连载中 · 9.7分神作",
    bgImage: "https://readdy.ai/api/search-image?query=ancient%20East%20Asian%20palace%20at%20night%20with%20moonlight%2C%20a%20mysterious%20warrior%20silhouette%20in%20traditional%20costume%2C%20atmospheric%20mist%20and%20lanterns%2C%20cinematic%20composition%2C%20dark%20warm%20tones%2C%20epic%20historical%20fantasy%20scene%2C%20Korean%20manhwa%20art%20style%20inspired%2C%20dramatic%20lighting&width=1400&height=600&seq=hero-banner-01&orientation=landscape",
    gradient: "from-amber-900/70 via-amber-800/40 to-black/70",
  },
  {
    id: 2,
    comicId: 4,
    title: "都市夜语 — 都市女性必读漫画",
    subtitle: "156话完结 · 9.5分口碑佳作 · 1.5亿阅读",
    bgImage: "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20night%20with%20beautiful%20neon%20reflections%2C%20elegant%20urban%20atmosphere%2C%20soft%20bokeh%20lights%2C%20sophisticated%20cityscape%2C%20warm%20and%20cool%20light%20contrast%2C%20cinematic%20wide%20shot%2C%20Korean%20drama%20aesthetic%2C%20emotional%20city%20night%20vibe&width=1400&height=600&seq=hero-banner-02&orientation=landscape",
    gradient: "from-slate-900/70 via-slate-800/40 to-black/70",
  },
  {
    id: 3,
    comicId: 11,
    title: "魔法学院优等生 — 奇幻冒险新篇章",
    subtitle: "180话连载中 · 9.5分 · 魔法对决盛宴",
    bgImage: "https://readdy.ai/api/search-image?query=magical%20academy%20with%20floating%20crystals%20and%20spell%20effects%2C%20fantasy%20castle%20interior%20with%20warm%20glowing%20light%2C%20colorful%20magic%20auras%2C%20enchanting%20atmosphere%2C%20cinematic%20fantasy%20scene%2C%20vibrant%20and%20mystical%2C%20Korean%20manhwa%20fantasy%20art%20style&width=1400&height=600&seq=hero-banner-03&orientation=landscape",
    gradient: "from-indigo-900/70 via-purple-800/40 to-black/70",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "漫画迷小王",
    avatar: "",
    rating: 5,
    content: "韩漫之家的画质太赞了！比其他平台清晰多了，翻译也很到位。每天必刷，已经推荐给身边所有喜欢漫画的朋友了！",
    date: "2026-07-28",
  },
  {
    id: 2,
    name: "爱吃泡菜的熊猫",
    avatar: "",
    rating: 5,
    content: "自从发现了韩漫之家，我的通勤时间再也不无聊了。更新速度超快，基本同步韩国那边的进度，爱了爱了！",
    date: "2026-07-25",
  },
  {
    id: 3,
    name: "夜猫子读者",
    avatar: "",
    rating: 5,
    content: "作为一个看了十年漫画的老读者，韩漫之家的阅读体验是我用过最好的。页面简洁没有广告干扰，收藏功能也很实用。",
    date: "2026-08-01",
  },
  {
    id: 4,
    name: "草莓味布丁",
    avatar: "",
    rating: 4,
    content: "分类很详细，找漫画特别方便。希望以后能增加更多完结作品，有些追得太辛苦了哈哈。不过内容质量真的没话说！",
    date: "2026-07-30",
  },
  {
    id: 5,
    name: "追更达人",
    avatar: "",
    rating: 5,
    content: "全站正版漫画这一点就很值得支持！现在盗版网站太多了，韩漫之家坚持正版真的不容易。订阅价格也很良心。",
    date: "2026-07-22",
  },
  {
    id: 6,
    name: "咖啡加漫画",
    avatar: "",
    rating: 5,
    content: "界面设计非常舒适，不像某些平台花里胡哨的。阅读模式很流畅，翻页手感极佳。已经是我手机上的必备APP了。",
    date: "2026-08-03",
  },
];

export const faqs = [
  {
    question: "韩漫之家的漫画都是正版的吗？",
    answer: "是的，韩漫之家平台上的所有漫画内容均获得韩国版权方的正式授权，确保每一位读者都能享受到正版、高质量的漫画阅读体验。我们与多家韩国知名漫画出版社和创作平台建立了长期合作关系。",
  },
  {
    question: "如何开始阅读漫画？",
    answer: "您可以直接在首页浏览推荐内容，或通过顶部的分类导航找到感兴趣的漫画。点击任意漫画封面即可进入详情页，然后选择章节开始阅读。无需注册即可浏览，但注册后可享受收藏、评论、订阅更新提醒等更多功能。",
  },
  {
    question: "韩漫之家的更新频率是怎样的？",
    answer: "我们与韩国版权方保持密切合作，大部分热门连载漫画可以实现与韩国同步更新。通常每周都会有固定的更新日，您可以在漫画详情页查看具体的更新计划。已完结作品则会一次性提供全部章节。",
  },
  {
    question: "阅读需要付费吗？",
    answer: "韩漫之家提供大量免费漫画供读者阅读。部分独家内容和最新章节可能需要消耗阅读券或订阅会员。我们也会定期举办免费阅读活动，让更多读者能够享受优质漫画内容。",
  },
  {
    question: "支持哪些设备阅读？",
    answer: "韩漫之家采用响应式设计，完美适配电脑、平板和手机等多种设备。您可以在任何设备上通过浏览器访问我们的网站，获得流畅的阅读体验。我们推荐使用移动设备获得最佳竖屏漫画阅读效果。",
  },
  {
    question: "如何联系客服？",
    answer: "您可以通过关于我们页面的联系表单发送您的问题，或发送邮件至我们的官方邮箱。我们的客服团队会在24小时内回复您的咨询。常见问题可在本FAQ区域快速找到答案。",
  },
];

export const siteInfo = {
  name: "韩漫之家",
  tagline: "海量正版韩国漫画在线阅读平台",
  description: "韩漫之家作为海量正版漫画的在线阅读平台，提供免费的韩国漫画大全，确保您的每次阅读都建立在正规资源基础之上。我们致力于为中文读者提供最新、最全、最高质量的韩国漫画资源。",
  email: "contact@hanmanzhijia.com",
  phone: "400-888-6688",
  address: "北京市朝阳区望京SOHO T2-A座 1806室",
  founded: "2019",
  totalComics: "5000+",
  totalUsers: "800万+",
  dailyActive: "50万+",
};